var React = require('react');

function IconSmArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M12 8l-6 5.668L7.41 15 12 10.673 16.59 15 18 13.668z","transform":"translate(-6 -8)"}));
}

IconSmArrowUp.defaultProps = {"width":"12","height":"7","viewBox":"0 0 12 7"};

module.exports = IconSmArrowUp;

IconSmArrowUp.default = IconSmArrowUp;
